import { Layout } from 'antd';
import {FC, ReactNode, useState} from 'react';
import i18n from 'i18next';
import {useLocation, useNavigate} from 'react-router-dom';
import MainMenu from 'pages/Account/MainMenu';
import { AccountLayoutLogoLink } from './AccountLayoutLogoLink';
import { AccountLayoutContent } from './AccountLayoutContent';
import styles from './index.module.scss';
import './index.scss';
import { useParams } from 'react-router';
import { ReactComponent as CollapsibleIcon} from '../../../assets/icons/double-arrow.svg'
import { ReactComponent as BackIcon} from '../../../assets/icons/back.svg'
import {ProjectTitle} from "../../../pages/Account/Invest/PrimaryMarket/PrimaryMarketProject/ProjectTitle";


const { t } = i18n;

type AccountLayoutProps = {
	children?: ReactNode;
};

type RouteItem = { pathname: string; title: any; isGreeting: boolean };

export const AccountLayout: FC<AccountLayoutProps> = ({ children }) => {
	const { pathname } = useLocation();
	const navigate = useNavigate();
	const params = useParams();
	const ROUTES: RouteItem[] = [
		{ pathname: 'news', title: t('newsAndInformationText'), isGreeting: false },
		{ pathname: 'overview', title: '', isGreeting: true },
		{ pathname: 'deposit', title: `${t('depositText')} / ${t('withdrawText')}`, isGreeting: false },
		{ pathname: 'withdraw', title: `${t('depositText')} / ${t('withdrawText')}`, isGreeting: false },
		{
			pathname: 'primarymarket',
			title: t('primaryMarketText'),
			isGreeting: false,
		},
		{
			pathname: 'projects',
			title: (
				<div className="primaryMarket__desktopTitle">
					<ProjectTitle />
				</div>
			),
			isGreeting: false,
		},
		{
			pathname: 'secondarymarket',
			title: t('secondaryMarketText'),
			isGreeting: false,
		},
		{
			pathname: 'statement',
			title: t('statementText'),
			isGreeting: false,
		},
		{
			pathname: 'settings',
			title: '',
			isGreeting: true,
		},
		{
			pathname: 'my-investments/sale',
			title: (
				<div className={styles.titleWithBack}>
					<a onClick={() => navigate(-1)}><BackIcon /></a>
					<>{t('sellMyInvestmentTextId', params)}</>
				</div>
			),
			isGreeting: false
		},
		{ pathname: 'my-investments', title: t('myInvestmentsText'), isGreeting: false },
		{
			pathname: 'investments',
			title: (
				<div className={styles.titleWithBack}>
					<a onClick={() => navigate(-1)}><BackIcon /></a>
					<>{t('investmentId', params)}</>
				</div>
			),
			isGreeting: false,
		},
	];
	const route = ROUTES.find((item) => pathname.includes(item.pathname)) || ({} as RouteItem);
	const [collapsed, setCollapsed] = useState(false);
	return (
		<Layout className={styles.root}>
			<Layout.Sider
				collapsible
				width={304}
				collapsedWidth={80}
				breakpoint="lg"
				className={styles.sider}
				collapsed={collapsed}
				onCollapse={(v) => setCollapsed(v)}
				trigger={
					<div className={styles.collapsible} data-collapsed={collapsed}>
						<CollapsibleIcon />
					</div>
				}
			>
				<AccountLayoutLogoLink className={styles.wrapper} collapsed={collapsed} />
				<MainMenu collapsed={collapsed} />
			</Layout.Sider>
			<AccountLayoutContent
				title={route.title}
				isGreeting={route.isGreeting}
			>
				{children}
			</AccountLayoutContent>
		</Layout>
	);
};
